import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

// Solid icons (Import them directly to avoid including ALL icons in build)
import {faBadgeCheck} from '@fortawesome/pro-solid-svg-icons/faBadgeCheck';
import {faBars} from '@fortawesome/pro-solid-svg-icons/faBars';
import {faCheckCircle} from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import {faCaretUp} from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import {faCaretDown} from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import {faPlus} from '@fortawesome/pro-solid-svg-icons/faPlus';
import {faAngleRight} from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import {faAngleLeft} from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import {faShoppingCart} from '@fortawesome/pro-solid-svg-icons/faShoppingCart';
import {faArrowUp} from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import {faArrowDown} from '@fortawesome/pro-solid-svg-icons/faArrowDown';

// Light icons (Import them directly to avoid including ALL icons in build)
import {faCircle} from '@fortawesome/pro-light-svg-icons/faCircle';
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import {faQrcode} from '@fortawesome/pro-light-svg-icons/faQrcode';
import {faSignOut} from '@fortawesome/pro-light-svg-icons/faSignOut';
import {faTrashAlt} from '@fortawesome/pro-light-svg-icons/faTrashAlt';
import {faEdit} from '@fortawesome/pro-light-svg-icons/faEdit';
import {faTimesCircle} from '@fortawesome/pro-light-svg-icons/faTimesCircle';

// Regular icons (Import them directly to avoid including ALL icons in build)

import {faChevronRight} from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import {faChevronCircleLeft} from '@fortawesome/pro-regular-svg-icons/faChevronCircleLeft';
import {faBackspace} from '@fortawesome/pro-regular-svg-icons/faBackspace';
import {Vue} from 'vue-property-decorator';


library.add(
	faQrcode,
	faBadgeCheck,
	faBars,
	faCircle,
	faTimes,
	faCheckCircle,
	faCaretUp,
	faCaretDown,
	faPlus,
	faSignOut,
	faAngleRight,
	faAngleLeft,
	faTrashAlt,
	faShoppingCart,
	faEdit,
	faArrowUp,
	faArrowDown,
	faTimesCircle,
	faChevronCircleLeft,
	faChevronRight,
	faBackspace
);

Vue.component('fa-icon', FontAwesomeIcon);
